import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column min-vh-100" }
const _hoisted_2 = {
  key: 0,
  class: "container container-fluid"
}
const _hoisted_3 = { class: "mb-5 border-bottom-light-grey" }
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = { class: "row restaurants-list mb-5" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "card-body px-3" }
const _hoisted_8 = { class: "card-title fw-bold mb-4 text-black" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-muted mb-0" }, " Date & Time ", -1)
const _hoisted_10 = { class: "text-black fw-bold" }
const _hoisted_11 = { class: "row mb-5" }
const _hoisted_12 = { class: "col-md-6 offset-md-3" }
const _hoisted_13 = {
  key: 1,
  class: "container container-fluid"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "mb-5 border-bottom-light-grey" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bold loading-skeleton w-25" }, "Title ")
], -1)
const _hoisted_15 = {
  key: 2,
  class: "fw-bold text-center mb-4"
}

import { ref } from 'vue';
import Header from '@/components/shared/PageHeader.vue';
import Footer from '@/components/shared/PageFooter.vue';
import PageTitle from '@/components/shared/PageTitle.vue';
import ListLoader from '@/components/shared/loaders/ListLoader.vue';
import { formatFullDate } from '@/utils/helper';
import { store } from '@/store';



export default /*#__PURE__*/_defineComponent({
  __name: 'Bookings',
  setup(__props) {

const currentPage = ref(1);
const totalBookings = ref(0);
const myBookingList = ref([]) as any;
const no_records = ref(false);
const hasNextPage = ref(false);

const Bookings = (page = 1) => {
    store.dispatch('getUserBookings', page).then((response) => {
        //hasNextPage.value = response.next !== null;
        totalBookings.value = response.count;

        if(response)
            myBookingList.value = [...myBookingList.value, ...response];

        no_records.value =  myBookingList.value.length === 0;
    }).catch((error) => {
        myBookingList.value = [];
        no_records.value = true;
        console.log(error);
    });
}

const loadMore = () => {
    currentPage.value += 1;
    Bookings(currentPage.value);
}

Bookings()

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Header),
    _createVNode(PageTitle, { title: "My Bookings" }),
    (_unref(myBookingList) && _unref(myBookingList).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, "You have " + _toDisplayString(_unref(myBookingList).length) + " booking(s) ", 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(myBookingList), (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id,
                class: "col-lg-3 col-md-4 col-sm-6 mb-4"
              }, [
                _createVNode(_component_router_link, {
                  to: `/bookings/${item.id}`,
                  class: "card shadow-sm rounded-3 border-0 h-100"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: item.restaurant?.featured_photo_thumbnails.cover_small,
                      class: "card-img-top",
                      alt: item.name
                    }, null, 8, _hoisted_6),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("h6", _hoisted_8, _toDisplayString(item.restaurant?.name), 1),
                      _hoisted_9,
                      _createElementVNode("small", _hoisted_10, _toDisplayString(_unref(formatFullDate)(item?.datetime ?? '')), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              (hasNextPage.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-primary btn-sm rounded-5 px-4 py-2 fw-bold w-100",
                    onClick: loadMore
                  }, "Load More"))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : (!no_records.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(ListLoader)
          ]))
        : _createCommentVNode("", true),
    (no_records.value)
      ? (_openBlock(), _createElementBlock("h5", _hoisted_15, " You don't have any bookings yet! "))
      : _createCommentVNode("", true),
    _createVNode(Footer)
  ]))
}
}

})